import { Component, OnInit } from '@angular/core';
import { FileExplorerService } from '../file-explorer.service';

@Component({
    selector: 'filemanager-dir-tree',
    templateUrl: './side.component.html',
    styleUrls: ['./tree.component.scss'],
    standalone: false
})

export class FileManagerDirTreeComponent implements OnInit {
  constructor(public fileExplorerService: FileExplorerService) { }

  ngOnInit() { }
}
